import {useFeatureService} from './use-feature-service';
import {CommonFeatureServices} from '../contexts/feature-app-environment-context';

export function useIsNestedFeatureApp(isTariffsFeatureApp?: boolean) {
  const customChannel = useFeatureService(
    isTariffsFeatureApp
      ? CommonFeatureServices.tariffsChanelService
      : CommonFeatureServices.layerButtonChanelService
  );

  return customChannel?.client.get() !== undefined;
}
